<template>
  <div class="login-page" :style="{ backgroundImage: 'url(/images/login-bg.png)' }">
    <div class="login-bg"></div>
    <div class="login-box">
      <div class="login-art">
        <img src="/images/login-art.png" alt="login" />
      </div>
      <div class="login-form">
        <div class="logo-area">
          <img src="/images/logo.png" class="logo" />
          <h2>远诺检测信息管理系统</h2>
        </div>
        <el-form ref="form" :model="form" label-width="0">
          <el-form-item prop="dlh">
            <el-input v-model="form.dlh" placeholder="请输入用户名" prefix-icon="el-icon-user" size="large"></el-input>
          </el-form-item>
          <el-form-item prop="mm">
            <el-input v-model="form.mm" type="password" placeholder="请输入密码" prefix-icon="el-icon-lock" size="large" @keyup.enter="login"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="large" class="btn-login" :loading="loading" @click="login">登 录</el-button>
          </el-form-item>
          <p v-if="err" class="err-msg">{{ err }}</p>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/utils/api'
import { setCurrentUser, resolveDefaultHomeRoute } from '@/utils/user'

export default {
  data() {
    return {
      form: { dlh: '', mm: '' },
      loading: false,
      err: ''
    }
  },
  methods: {
    async login() {
      if (!this.form.dlh || !this.form.mm) { this.err = '请输入用户名和密码'; return }
      this.loading = true; this.err = ''
      try {
        const res = await api.get('yn_login', this.form)
        if (res.data && res.data.id) {
          const u = { ...res.data }
          if (!u.dlh) u.dlh = this.form.dlh
          setCurrentUser(u)
          this.$router.push(resolveDefaultHomeRoute(u)).catch(() => {})
        } else {
          this.err = '用户名或密码错误'
        }
      } catch (e) { this.err = '网络错误' }
      this.loading = false
    }
  }
}
</script>

<style scoped>
.login-page {
  width: 100%; height: 100%;
  background: center/cover no-repeat;
  display: flex; align-items: center; justify-content: center;
}
.login-box {
  display: flex; background: #fff; border-radius: 16px;
  box-shadow: 0 8px 40px rgba(0,0,0,.15); overflow: hidden;
}
.login-art { width: 400px; display: flex; align-items: center; justify-content: center; background: #f5f8ff; padding: 40px; }
.login-art img { max-width: 100%; }
.login-form { width: 380px; padding: 50px 40px; }
.logo-area { text-align: center; margin-bottom: 36px; }
.logo { height: 48px; margin-bottom: 10px; }
.logo-area h2 { font-size: 20px; color: #1a56db; margin: 0; font-weight: 600; }
.btn-login { width: 100%; }
.err-msg { color: #e74c3c; text-align: center; font-size: 13px; }
</style>
